import React from "react"
import styled from "styled-components"
import RadioButton from "../../common/commerce/radio-button/radio-button.component"
import { noop } from "lodash"
import { AppFunctionComponent, ContentfulVariant } from "../../../types"

interface ColorRadioUIProps {
  inputSize: number
  inputSpace: number
  color: string
  image?: string
  spaceBetween?: number
}

export const ColorRadioButton = styled(RadioButton)<ColorRadioUIProps>`
  --color-input-size: ${(props) => props.inputSize}px;
  --color-space: ${(props) => props.inputSpace}px;
  --space-between: ${(props) => props.spaceBetween ?? 12}px;

  span {
    display: none;
  }
  div {
    width: var(--color-input-size);
    height: var(--color-input-size);
    margin-right: var(--space-between);
    &::after {
      border: 1px solid ${({ theme }) => theme.color.borderLight};
      width: calc(var(--color-input-size) - var(--color-space));
      height: calc(var(--color-input-size) - var(--color-space));
      background-image: url(${({ image }) => image || ""});
      background-repeat: no-repeat;
      background-position: center;
      background-size: calc(var(--color-input-size) - var(--color-space) + 4px);
      background-color: ${({ color }) => color || ""};
      opacity: 1;
      visibility: visible;
    }
  }

  input {
    &:checked {
      + div {
        border: 2px solid ${({ theme }) => theme.color.commerceBlueTransparent};
      }
    }
  }
`

interface Props {
  products: Array<ContentfulVariant & { image?: string }>
  active?: string
  namePrefix?: string
  inputSize?: number
  inputSpace?: number
  spaceBetween?: number
  onChange?: (value: string) => void
  changeOnHover?: boolean
  className?: string
}

export const ColorWrapper = styled.div`
  display: flex;
`

const ColorSelectRadioUI: AppFunctionComponent<Props> = ({
  products,
  active,
  namePrefix = "",
  inputSize = 50,
  inputSpace = 14,
  spaceBetween,
  onChange = noop,
  changeOnHover = false,
  className,
}) => {
  const handleChangeColor = (value: string) => {
    onChange(value)
  }

  const handleChangeOnHover = (value: string) => {
    if (changeOnHover) {
      handleChangeColor(value)
    }
  }

  return (
    <ColorWrapper className={className}>
      {products.map((item) => {
        return item.colorHex ? (
          <ColorRadioButton
            id={`${namePrefix}-${item.sku}`}
            inputSize={inputSize}
            inputSpace={inputSpace}
            spaceBetween={spaceBetween}
            name={`${namePrefix}-color`}
            key={`${namePrefix}-${item.sku}`}
            color={item.colorHex}
            image={item.image}
            label={item.colorName}
            value={item.colorName}
            onChange={handleChangeColor}
            onMouseEnter={handleChangeOnHover}
            defaultChecked={active === item.colorName}
          />
        ) : null
      })}
    </ColorWrapper>
  )
}

export default ColorSelectRadioUI
